<div class="e-view-bar" role="region">
    <div>
        <div class="e-view-as-select">
            <label>View As</label>
            <mat-form-field appearance="fill">
                <mat-select name="selectedTableAggregation" [(ngModel)]="selectedTableAggregation"
                    panelClass="e-mat-select-panel" (selectionChange)="onSKUsViewChange($event)">
                    <mat-option *ngFor="let aggregation of tableAggregations" [value]="aggregation.value">
                        {{ aggregation.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <via-info-icon [tooltipText]="viewAsTooltipText"></via-info-icon>
        </div>
        <div class="e-sort-by-select">
            <label>Sort By</label>
            <mat-form-field appearance="fill">
                <mat-select name="selectedSortType" (selectionChange)="onSortByChange()" [(ngModel)]="selectedSortType" panelClass="e-mat-select-panel">
                    <mat-option *ngFor="let option of sortByTypes" [value]="option.value">
                        {{ option.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div>
            <button class="e-sort-order-button" [class.e-ascending]="sortOrder === 'ascending'"
                (click)="toggleSortOrder()" aria-label="Order results ascending or descending">
                Order
            </button>
        </div>
    </div>
    <div>
        <button (click)="navigateToConfigureData()" mat-button color="primary">Configure & Export</button>
    </div>
</div>

<div class="e-filter-bar" role="region">
    <div class="e-price-per-select">
        <label>Price Per</label>
        <mat-form-field appearance="fill">
            <mat-select name="selectedPricePerOption" [(ngModel)]="selectedPricePerOption"
                panelClass="e-mat-select-panel-compact"
                (selectionChange)="updatePricePer($event)"
                [disabled]="false">
                <mat-option *ngFor="let option of pricePerOptions" [value]="option.value">
                    {{ option.label }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <via-info-icon [tooltipText]="pricePointTooltipText"></via-info-icon>
    </div>
    <div class="e-currency-select">
        <label>Currency</label>
        <via-ui-currency-dropdown [selectedCurrency]="selectedCurrency" (currencyChange)="updateCurrency($event)"></via-ui-currency-dropdown>
    </div>
    <div class="e-exchange-rate-button">
        <label>Ex. Rate</label>
        <button (click)="openCurrencyConversionModal()" aria-label="Open currency conversion table">Open</button>
        <via-info-icon [tooltipText]="exRateTooltipText"></via-info-icon>
    </div>
    <div class="e-date-range-select">
        <label>Date</label>
        <via-date-range (onDateRangeChange)="updateDateRange($event)"
            [datePickerSettings]="dateSettings"></via-date-range>
    </div>
    <div class="e-frequency-select">
        <label>Frequency</label>
        <via-ui-frequency-dropdown [selectedFrequency]="this.configureData.frequency"
            (frequencyChange)="updateFrequency($event)" [panelClass]="'e-mat-select-panel-compact'">
        </via-ui-frequency-dropdown>
    </div>
    <div class="e-price-displayed-options">
        <label>Price displayed</label>
        <div>
            <mat-radio-group aria-label="Select an option">
                <mat-radio-button *ngFor="let priceDisplay of priceDisplays"
                    [checked]="isPriceDisplayChecked(priceDisplay.value)" [value]="priceDisplay.value" (click)="updatePriceDisplayed(priceDisplay.value)">
                    {{ priceDisplay.label }}
                    <via-info-icon [tooltipText]="priceDisplay.tooltip"></via-info-icon>
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
    <div class="e-show-prices-checkbox">
        <label>Show all</label>
        <mat-checkbox [(ngModel)]="isShowingAllPrices" (change)="updateShowAllPrices()">Prices</mat-checkbox>
    </div>
</div>
